import axios from 'axios';
import config from '../../config';
import StorageManager from '../../utils/storageManager';
import carBuyService from './carBuyService';

const verintService = {
  token: null,
  expiresAt: null,

  async fetchToken() {
    // return cached token if still valid
    if (this.token && Date.now() < this.expiresAt) {
      return this.token;
    }

    const carbuyJwt = StorageManager.getJWT('CarBuyServiceJWT');

    try {
      const response = await axios.get(
        config.carbuyservice + '/Verint/GetToken',
        {
          headers: { Authorization: `Bearer ${carbuyJwt}` },
        }
      );
      this.token = response.data.access_token;
      this.expiresAt = response.data.expires_in;
    } catch (err) {
      return { data: err.message };
    }
  },

  async setVerintCallDisposition(payload) {
    return carBuyService.patch(
      '/Verint/SetVerintCallDisposition',
      payload,
      true
    );
  },
  async GetVerintInteraction(payload) {
    return carBuyService.get(
      '/Verint/GetVerintInteraction',
      { params: payload },
      true
    );
  },

  clearToken() {
    this.token = null;
    this.expiresAt = null;
  },
};

export default verintService;



// WEBPACK FOOTER //
// ./src/api/clients/verintService.js